import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonsModule } from '~shared/components/buttons/buttons.module';

import { WorkspaceFormComponent } from './workspace-form.component';

/**
 * Module for the workspace form component
 * It fetches the ButtonsModule to provide the submit row buttons
 */
@NgModule({
  declarations: [WorkspaceFormComponent],
  exports: [WorkspaceFormComponent],
  imports: [
    ButtonsModule,
    ReactiveFormsModule,
    FormsModule
  ],
  providers: [],
})
export class WorkspaceFormModule { }
